/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { PropertyType } from '../types/utils';

export class CreatePropertyInput {
	key: string = ''

	properties?: Array<CreatePropertyInput>

	type: PropertyType = PropertyType.RICH_TEXT

	value: string = ''
}